import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import React from "react";
export default function DeleteCard({ isOpen, onHide, deleteCardFunc, loader }) {
    return (
        <Modal show={isOpen}
            onHide={onHide}
            className="custom-modal">
            <Modal.Header className="p-0 m-0">
                <h5 className="edit-title"> Confirm</h5>
                <button type="button" onClick={onHide} className="btn-close text-dark close-button"></button>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this card?</Modal.Body>
            <Modal.Footer className="pt-3">
                <Button disabled={loader} className="m-0 me-2" variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button disabled={loader} variant="primary" className="agree-button confirmbtn m-0" onClick={deleteCardFunc}>
                    {loader && (
                        <i className="animateSpin fa-solid fa-circle-notch"></i>
                    )}
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
